module.exports = __webpack_public_path__ + "img/pick-up1.5f9f57d0.jpg";